import { MantineThemeColors } from "@mantine/core";

import { Severity as SeverityProto } from "@protos/common/v1/common";
import { SeverityStr } from "@shared/types";

import { severityStrToProto } from "../severity";

/**
 * Deprecated. Use `getSeverityColorScheme` instead (which uses the proper `Severity` proto enum instead of the deprecated string union.)
 */
export const getColorSchemeFromSeverityStr = (
  colors: MantineThemeColors,
  severityStr: SeverityStr
) => {
  return getSeverityColorScheme(colors, severityStrToProto(severityStr));
};

export const getSeverityColorScheme = (
  colors: MantineThemeColors,
  severity: SeverityProto
) => {
  switch (severity) {
    case SeverityProto.LOW:
      return {
        color: colors["cyan"],
        backgroundShade: 1,
        iconShade: 5,
        textShade: 6,
        textColor: colors["gray"][7],
        borderColor: colors["cyan"][4],
      };
    case SeverityProto.MEDIUM:
      return {
        color: colors["orange"],
        backgroundShade: 4,
        iconShade: 6,
        textShade: 7,
        textColor: colors["gray"][7],
        borderColor: colors["orange"][5],
      };
    case SeverityProto.CRITICAL:
      return {
        color: colors["red"],
        backgroundShade: 9,
        iconShade: 9,
        textShade: 9,
        textColor: "#fff",
        borderColor: colors["red"][9],
      };
    case SeverityProto.HIGH:
    default:
      return {
        color: colors["red"],
        backgroundShade: 7,
        iconShade: 8,
        textShade: 9,
        textColor: "#fff",
        borderColor: colors["red"][8],
      };
  }
};

// TODO add color scheme for info when we have that severity
// info
// {
//   color: colors["gray"],
//   backgroundShade: 0,
//   iconShade: 6,
//   textShade: 7,
// }
